import { render, staticRenderFns } from "./funnelGraph.vue?vue&type=template&id=38f84a9b&"
import script from "./funnelGraph.vue?vue&type=script&lang=js&"
export * from "./funnelGraph.vue?vue&type=script&lang=js&"
import style0 from "./funnelGraph.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports